//$FlowFixMe
import choices from '../../assets/choices.webp'
//$FlowFixMe
import onlyWinStamp from 'app/tu-preferes-king/assets/only-win-stamp.webp'
import React from 'react'
import {
    StyledBlock,
    StyledBodyContainer,
    StyledExplanationBlockContainer,
    StyledExplanationsContainer,
    StyledIllustrationContainer,
    StyledStampContainer,
    StyledTitleContainer
} from './styles'
import { useIntl } from 'react-intl'
import { colors } from 'shared/assets/styles'
import { H3, H4 } from '../../../../common/typography'
import { fonts } from 'app-v2/design-systems/typography/fonts'
import { useWindowDimensions } from '../../../utils'
import { breakpoints } from '../../../../assets/styles'
import { ListItem } from './components/ListItem'

export const ExplanationsToPlay = () => {
    const intl = useIntl()
    const { width: windowWidth } = useWindowDimensions()
    const isSmall = windowWidth <= breakpoints.small
    const Title = isSmall ? H3 : H4
    return (
        <>
            <StyledExplanationsContainer>
                <StyledExplanationBlockContainer>
                    <StyledBlock>
                        <StyledStampContainer>
                            <img src={onlyWinStamp} alt={'onlyWinStamp'} />
                        </StyledStampContainer>
                        <StyledTitleContainer>
                            <Title
                                color={colors.bbqBrown}
                                font={fonts.flameBold}>
                                {intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanations.1.title'
                                })}
                            </Title>
                        </StyledTitleContainer>
                        <StyledBodyContainer>
                            <ListItem
                                number={1}
                                text={intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanations.1.text.1'
                                })}
                            />
                            <ListItem
                                number={2}
                                text={intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanations.1.text.2'
                                })}
                            />
                            <ListItem
                                number={3}
                                text={intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanations.1.text.3'
                                })}
                            />
                            <ListItem
                                number={4}
                                text={intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanations.1.text.4'
                                })}
                            />
                            <ListItem
                                number={5}
                                text={intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanations.1.text.5'
                                })}
                            />
                        </StyledBodyContainer>
                        {isSmall && (
                            <StyledIllustrationContainer>
                                <img src={choices} alt={'choices'} />
                            </StyledIllustrationContainer>
                        )}
                    </StyledBlock>
                </StyledExplanationBlockContainer>
                {!isSmall && (
                    <StyledIllustrationContainer>
                        <img src={choices} alt={'choices'} />
                    </StyledIllustrationContainer>
                )}
            </StyledExplanationsContainer>
        </>
    )
}
